{
  "HELP_CENTER": {
    "TITLE": "Центр поддержки",
    "NEW_PAGE": {
      "DESCRIPTION": "Создайте порталы самообслуживания для вашего центра поддержки. Помогите вашим клиентам быстро находить ответы, без ожидания. Оптимизируйте запросы, повысите эффективность агентов и улучшите поддержку клиентов.",
      "CREATE_PORTAL_BUTTON": "Создать портал"
    },
    "HEADER": {
      "FILTER": "Фильтровать по",
      "SORT": "Сортировать по",
      "LOCALE": "Язык",
      "SETTINGS_BUTTON": "Настройки",
      "NEW_BUTTON": "Новая статья",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Опубликовано",
        "DRAFT": "Черновик",
        "ARCHIVED": "Архив"
      },
      "TITLES": {
        "ALL_ARTICLES": "Все статьи",
        "MINE": "Мои статьи",
        "DRAFT": "Черновики статей",
        "ARCHIVED": "Архивы статей"
      },
      "LOCALE_SELECT": {
        "TITLE": "Выберите язык",
        "PLACEHOLDER": "Выберите язык",
        "NO_RESULT": "Язык не найден",
        "SEARCH_PLACEHOLDER": "Поиск языка"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Все статьи",
      "PUBLISH_BUTTON": "Опубликовано",
      "MOVE_TO_ARCHIVE_BUTTON": "Переместить в архив",
      "PREVIEW": "Предпросмотр",
      "ADD_TRANSLATION": "Добавить перевод",
      "OPEN_SIDEBAR": "Открыть боковую панель",
      "CLOSE_SIDEBAR": "Закрыть боковую панель",
      "SAVING": "Сохранение...",
      "SAVED": "Сохранено"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Загрузить изображение",
        "UPLOADING": "Загружаем...",
        "SUCCESS": "Изображение успешно загружено",
        "ERROR": "Ошибка при загрузке изображения",
        "UN_AUTHORIZED_ERROR": "У вас нет прав для загрузки изображений",
        "ERROR_FILE_SIZE": "Размер изображения должен быть меньше, чем {size}MB",
        "ERROR_FILE_FORMAT": "Формат изображения должен быть jpg, jpeg или png",
        "ERROR_FILE_DIMENSIONS": "Размеры изображения должны быть меньше, чем 2000 x 2000"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Настройки статей",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Категория",
          "TITLE": "Выберите категорию",
          "PLACEHOLDER": "Выберите категорию",
          "NO_RESULT": "Не найдено категорий",
          "SEARCH_PLACEHOLDER": "Поиск категории"
        },
        "AUTHOR": {
          "LABEL": "Автор",
          "TITLE": "Выбрать автора",
          "PLACEHOLDER": "Выбрать автора",
          "NO_RESULT": "Авторов не найдено",
          "SEARCH_PLACEHOLDER": "Поиск автора"
        },
        "META_TITLE": {
          "LABEL": "Мета-заголовок",
          "PLACEHOLDER": "Добавит мета заголовок"
        },
        "META_DESCRIPTION": {
          "LABEL": "Мета описание",
          "PLACEHOLDER": "Добавьте мета-описание для лучших SEO результатов..."
        },
        "META_TAGS": {
          "LABEL": "Мета теги",
          "PLACEHOLDER": "Добавить мета-теги, разделенные запятыми..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Архивы статей",
        "DELETE": "Удалить статью"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Без категории",
      "SEARCH_RESULTS": "Результаты поиска {query}",
      "EMPTY_TEXT": "Поиск статей для вставки в ответы.",
      "SEARCH_LOADER": "Идёт поиск...",
      "INSERT_ARTICLE": "Вставить",
      "NO_RESULT": "Статьи не найдены",
      "COPY_LINK": "Скопировать ссылку статьи в буфер",
      "OPEN_LINK": "Открыть статью в новой вкладке",
      "PREVIEW_LINK": "Предпросмотр статьи"
    },
    "PORTAL": {
      "HEADER": "Портал",
      "DEFAULT": "По умолчанию",
      "NEW_BUTTON": "Новый портал",
      "ACTIVE_BADGE": "активно",
      "CHOOSE_LOCALE_LABEL": "Выберите локаль",
      "LOADING_MESSAGE": "Загрузка порталов...",
      "ARTICLES_LABEL": "статьи",
      "NO_PORTALS_MESSAGE": "Нет доступных порталов",
      "ADD_NEW_LOCALE": "Добавить новую локаль",
      "POPOVER": {
        "TITLE": "Портал",
        "PORTAL_SETTINGS": "Настройки портала",
        "SUBTITLE": "У вас есть несколько порталов и могут иметь разные локали для каждого портала.",
        "CANCEL_BUTTON_LABEL": "Отменить",
        "CHOOSE_LOCALE_BUTTON": "Выберите локаль"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "статьи",
            "ADD": "Добавить локали",
            "VISIT": "Посетить сайт",
            "SETTINGS": "Настройки",
            "DELETE": "Удалить"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Конфигурации портала",
            "ITEMS": {
              "NAME": "Имя",
              "DOMAIN": "Свой домен",
              "SLUG": "Метка",
              "TITLE": "Название портала",
              "THEME": "Цвет темы",
              "SUB_TEXT": "Подтекст портала"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Доступные локали",
            "TABLE": {
              "NAME": "Локальное имя",
              "CODE": "Код локали",
              "ARTICLE_COUNT": "№ статей",
              "CATEGORIES": "№ категорий",
              "SWAP": "Поменять",
              "DELETE": "Удалить",
              "DEFAULT_LOCALE": "По умолчанию"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Удалить портал",
          "MESSAGE": "Вы уверены, что хотите удалить этот портал",
          "YES": "Да, удалить портал",
          "NO": "Нет, сохранить портал",
          "API": {
            "DELETE_SUCCESS": "Портал успешно удален",
            "DELETE_ERROR": "Ошибка при удалении портала"
          }
        },
        "SEND_CNAME_INSTRUCTIONS": {
          "API": {
            "SUCCESS_MESSAGE": "Инструкции CNAME успешно отправлены",
            "ERROR_MESSAGE": "Ошибка при отправке инструкций CNAME"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Редактировать портал",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Основная информация"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Настройка портала"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Категории"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Locales"
          }
        },
        "CATEGORIES": {
          "TITLE": "Категории в",
          "NEW_CATEGORY": "Новая категория",
          "TABLE": {
            "NAME": "Имя",
            "DESCRIPTION": "Описание",
            "LOCALE": "Local",
            "ARTICLE_COUNT": "№ статей",
            "ACTION_BUTTON": {
              "EDIT": "Редактировать категорию",
              "DELETE": "Удалить категорию"
            },
            "EMPTY_TEXT": "Категорий не найдено"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Обновить основные настройки"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Информация справочного центра",
            "BODY": "Основная информация о портале"
          },
          "CUSTOMIZATION": {
            "TITLE": "Информация справочного центра",
            "BODY": "Настройка портала"
          },
          "FINISH": {
            "TITLE": "Ура! 🎉",
            "BODY": "Всё готово!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Назад",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Создать портал",
            "TITLE": "Информация справочного центра",
            "CREATE_BASIC_SETTING_BUTTON": "Создать базовые настройки портала"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Настройки портала",
            "TITLE": "Информация справочного центра",
            "UPDATE_PORTAL_BUTTON": "Обновить настройки портала"
          },
          "FINISH_PAGE": {
            "TITLE": "Ура!🎉 Все готово!",
            "MESSAGE": "Теперь вы можете видеть этот созданный портал на вашей странице порталов.",
            "FINISH": "Перейти на страницу всех порталов"
          }
        },
        "LOGO": {
          "LABEL": "Логотип",
          "UPLOAD_BUTTON": "Загрузить логотип",
          "HELP_TEXT": "Этот логотип будет показан в заголовке портала.",
          "IMAGE_UPLOAD_SUCCESS": "Логотип успешно загружен",
          "IMAGE_UPLOAD_ERROR": "Логотип успешно удалён",
          "IMAGE_DELETE_ERROR": "Ошибка при удалении логотипа"
        },
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя портала",
          "HELP_TEXT": "Название будет использоваться на публичном портале.",
          "ERROR": "Необходимо указать имя"
        },
        "SLUG": {
          "LABEL": "Метка",
          "PLACEHOLDER": "Слаг портала для url",
          "ERROR": "Необходимо указать метку"
        },
        "DOMAIN": {
          "LABEL": "Пользовательский домен",
          "PLACEHOLDER": "Пользовательский домен портала",
          "HELP_TEXT": "Добавьте только если вы хотите использовать пользовательский домен для ваших порталов. Например: {exampleURL}",
          "ERROR": "Введите корректный адрес домена"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Домашняя ссылка",
          "PLACEHOLDER": "Ссылка на главную страницу портала",
          "HELP_TEXT": "Ссылка, используемая для возврата с портала на главную страницу. Например: {exampleURL}",
          "ERROR": "Введите корректный URL главной страницы"
        },
        "THEME_COLOR": {
          "LABEL": "Цвет темы портала",
          "HELP_TEXT": "Этот цвет будет отображаться в качестве цвета темы портала."
        },
        "PAGE_TITLE": {
          "LABEL": "Название страницы",
          "PLACEHOLDER": "Заголовок страницы портала",
          "HELP_TEXT": "Название будет использоваться на публичном портале.",
          "ERROR": "Необходимо указать название"
        },
        "HEADER_TEXT": {
          "LABEL": "Header текст",
          "PLACEHOLDER": "Текст заголовка портала",
          "HELP_TEXT": "Название будет использоваться на публичном портале.",
          "ERROR": "Необходимо ввести текст заголовка портала"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Портал создан успешно.",
          "ERROR_MESSAGE_FOR_BASIC": "Не удалось создать портал. Попробуйте еще раз.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Портал успешно обновлен.",
          "ERROR_MESSAGE_FOR_UPDATE": "Не удалось создать портал. Попробуйте еще раз."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Добавить новую локаль",
        "SUB_TITLE": "Это добавляет новую локализацию в ваш список доступных переводов.",
        "PORTAL": "Портал",
        "LOCALE": {
          "LABEL": "Local",
          "PLACEHOLDER": "Выберите локаль",
          "ERROR": "Требуется локаль"
        },
        "BUTTONS": {
          "CREATE": "Создать локаль",
          "CANCEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Локаль успешно добавлен",
          "ERROR_MESSAGE": "Не удалось добавить локаль. Попробуйте еще раз."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Локаль по умолчанию успешно обновлена",
          "ERROR_MESSAGE": "Не удалось обновить локаль по умолчанию. Повторите попытку."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Локаль успешно удалена из портала",
          "ERROR_MESSAGE": "Невозможно удалить локаль из портала. Повторите попытку."
        }
      },
      "DRAFT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale moved to draft successfully",
          "ERROR_MESSAGE": "Unable to move locale to draft. Try again."
        }
      },
      "PUBLISH_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "Locale published successfully",
          "ERROR_MESSAGE": "Unable to publish locale. Try again."
        }
      }
    },
    "TABLE": {
      "LOADING_MESSAGE": "Загрузка статей...",
      "404": "Нет статей, соответствующих вашему запросу 🔍",
      "NO_ARTICLES": "Нет доступных статей",
      "HEADERS": {
        "TITLE": "Название",
        "CATEGORY": "Категория",
        "READ_COUNT": "Просмотры",
        "STATUS": "Статус",
        "LAST_EDITED": "Последнее изменение"
      },
      "COLUMNS": {
        "BY": "От",
        "AUTHOR_NOT_AVAILABLE": "Автор недоступен"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Загрузка статей...",
      "TITLE_PLACEHOLDER": "Название статьи",
      "CONTENT_PLACEHOLDER": "Напишите свою статью здесь",
      "API": {
        "ERROR": "Ошибка при сохранении статьи"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "Ошибка при публикации статьи",
        "SUCCESS": "Статья успешно опубликована"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "Ошибка при сохранении статьи",
        "SUCCESS": "Статья успешно архивирована"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "Ошибка при написании статьи",
        "SUCCESS": "Статья успешно подготовлена"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Подтвердите удаление",
          "MESSAGE": "Вы уверены, что хотите удалить статью?",
          "YES": "Да, удалить",
          "NO": "Нет, не удалять"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Статья успешно удалена",
        "ERROR_MESSAGE": "Ошибка при удалении статьи"
      }
    },
    "REORDER_ARTICLE": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder articles. Please try again."
      }
    },
    "REORDER_CATEGORY": {
      "API": {
        "ERROR_MESSAGE": "Unable to reorder categories. Please try again."
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Пожалуйста, добавьте заголовок статьи и контент, а затем только вы можете обновить настройки"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Поиск статей"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Создать категорию",
        "SUB_TITLE": "Категория будет использоваться в публичном портале для классификации статей.",
        "PORTAL": "Портал",
        "LOCALE": "Local",
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя категории",
          "HELP_TEXT": "Название категории будет использоваться на портале общего доступа для классификации статей.",
          "ERROR": "Необходимо указать имя"
        },
        "SLUG": {
          "LABEL": "Метка",
          "PLACEHOLDER": "Метка категории для url",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Необходимо указать метку"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Укажите краткое описание категории.",
          "ERROR": "Необходимо описание"
        },
        "BUTTONS": {
          "CREATE": "Создать категорию",
          "CANCEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категория успешно создана",
          "ERROR_MESSAGE": "Не удалось создать категорию"
        }
      },
      "EDIT": {
        "TITLE": "Редактировать категорию",
        "SUB_TITLE": "Изменение категории обновит категорию на портале.",
        "PORTAL": "Портал",
        "LOCALE": "Local",
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя категории",
          "HELP_TEXT": "Название категории будет использоваться на портале общего доступа для классификации статей.",
          "ERROR": "Необходимо указать имя"
        },
        "SLUG": {
          "LABEL": "Метка",
          "PLACEHOLDER": "Метка категории для url",
          "HELP_TEXT": "app.chatwoot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "Необходимо указать метку"
        },
        "DESCRIPTION": {
          "LABEL": "Описание",
          "PLACEHOLDER": "Укажите краткое описание категории.",
          "ERROR": "Необходимо описание"
        },
        "BUTTONS": {
          "CREATE": "Обновить категорию",
          "CANCEL": "Отменить"
        },
        "API": {
          "SUCCESS_MESSAGE": "Категория успешно обновлена",
          "ERROR_MESSAGE": "Не удается обновить категорию"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Категория успешно удалена",
          "ERROR_MESSAGE": "Не удается удалить категорию"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Поиск статей",
      "PLACEHOLDER": "Поиск статей",
      "NO_RESULT": "Статьи не найдены",
      "SEARCHING": "Идёт поиск...",
      "SEARCH_BUTTON": "Поиск",
      "INSERT_ARTICLE": "Вставить ссылку",
      "IFRAME_ERROR": "URL пуст или недействителен. Невозможно отобразить содержимое.",
      "OPEN_ARTICLE_SEARCH": "Вставить статью из справочного центра",
      "SUCCESS_ARTICLE_INSERTED": "Статья успешно вставлена",
      "PREVIEW_LINK": "Предпросмотр статьи",
      "CANCEL": "Закрыть",
      "BACK": "Назад",
      "BACK_RESULTS": "Назад к результатам"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Центр поддержки",
      "DESCRIPTION": "Создайте удобные для пользователя порталы самообслуживания. Помогите пользователям получить доступ к материалам и получите поддержку 24/7. Обновите свою подписку, чтобы включить эту функцию.",
      "SELF_HOSTED_DESCRIPTION": "Создавайте пользовательские порталы самообслуживания. Помогите пользователям получить доступ к материалам и получите поддержку 24/7. Обратитесь к администратору, чтобы включить эту функцию.",
      "BUTTON": {
        "LEARN_MORE": "Узнайте больше",
        "UPGRADE": "Обновить"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Несколько порталов",
          "DESCRIPTION": "Создайте несколько порталов справочного центра для разных товаров с использованием одного аккаунта."
        },
        "LOCALES": {
          "TITLE": "Полная поддержка языков",
          "DESCRIPTION": "Локализация портала на вашем языке. Мы поддерживаем все локали и разрешаем переводы для каждой статьи."
        },
        "SEO": {
          "TITLE": "SEO-удобный дизайн",
          "DESCRIPTION": "Настройте мета-теги для улучшения видимости поисковых систем на наших SEO-страницах."
        },
        "API": {
          "TITLE": "Полная поддержка API",
          "DESCRIPTION": "Используйте портал в качестве бесконечного CMS с сторонними фронт-фреймворками, используя наши API."
        }
      }
    },
    "LOADING": "Загрузка...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} просмотр | {count} просмотров",
          "DROPDOWN_MENU": {
            "PUBLISH": "Опубликовано",
            "DRAFT": "Черновик",
            "ARCHIVE": "Архив",
            "TRANSLATE": "Перевести",
            "DELETE": "Удалить"
          },
          "STATUS": {
            "DRAFT": "Черновик",
            "PUBLISHED": "Опубликовано",
            "ARCHIVED": "Архив"
          },
          "PENDING_EDITS": "Unpublished edits",
          "PENDING_EDITS_TOOLTIP": "This published article has unpublished edits",
          "CATEGORY": {
            "UNCATEGORISED": "Без категории"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Все статьи",
          "MINE": "Мои",
          "DRAFT": "Черновик",
          "PUBLISHED": "Опубликовано",
          "ARCHIVED": "Архив"
        },
        "CATEGORY": {
          "ALL": "Все категории"
        },
        "LOCALE": {
          "ALL": "Все локали"
        },
        "SEARCH_PLACEHOLDER": "Поиск статей...",
        "NEW_ARTICLE": "Новая статья"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Написать статью",
          "SUBTITLE": "Напишите насыщенную статью, давайте начнем!",
          "BUTTON_LABEL": "Новая статья"
        },
        "MINE": {
          "TITLE": "Вы не написали ни одной статьи здесь",
          "SUBTITLE": "Все статьи, написанные вами, показываются здесь для быстрого доступа."
        },
        "DRAFT": {
          "TITLE": "Нет статей в черновиках",
          "SUBTITLE": "Черновики статей будут появляться здесь"
        },
        "PUBLISHED": {
          "TITLE": "Нет опубликованных статей",
          "SUBTITLE": "Опубликованные статьи появятся здесь"
        },
        "ARCHIVED": {
          "TITLE": "В архиве нет статей",
          "SUBTITLE": "Архивные статьи не отображаются на портале, вы можете использовать их для обозначения ненужных или устаревших страниц"
        },
        "CATEGORY": {
          "TITLE": "В этой категории нет статей",
          "SUBTITLE": "Статьи в этой категории будут отображаться здесь"
        },
        "SEARCH": {
          "TITLE": "No matching articles",
          "SUBTITLE": "We couldn't find any articles matching your search. Try a different term."
        }
      },
      "BULK_TRANSLATE": {
        "TITLE": "Перевести статью | Перевести статьи {count}",
        "DESCRIPTION": "Перевод выбранной статьи на другой язык. | Перевести выбранные статьи на другой язык.",
        "LOCALE_LABEL": "Целевой язык",
        "LOCALE_PLACEHOLDER": "Выбрать язык",
        "CATEGORY_LABEL": "Целевая категория",
        "CATEGORY_PLACEHOLDER": "Выберите категорию",
        "OPTIONAL": "(не обязательно)",
        "CONFIRM": "Перевести",
        "SELECT_ALL": "Выбрать все ({count})",
        "SELECTED_COUNT": "Выбрано {count}",
        "CLEAR_SELECTION": "Clear selection",
        "TRANSLATE_BUTTON": "Перевести",
        "CONFIRM_OVERWRITE": "Перезаписать и перевести",
        "DUPLICATE_WARNING": "Перевод для этой статьи уже существует на выбранном языке. | Переводы уже существуют для {count} статей на выбранном языке.",
        "DUPLICATE_CONFIRM_HINT": "Нажмите еще раз для перезаписи существующего перевода.",
        "API": {
          "SUCCESS_MESSAGE": "Перевод в процессе. Статья будет отображаться в виде проекта, как только будет готова.",
          "ERROR_MESSAGE": "Не удалось начать перевод. Попробуйте еще раз."
        }
      },
      "BULK_ACTIONS": {
        "PUBLISH": "Опубликовано",
        "DRAFT": "Черновик",
        "ARCHIVE": "Архив",
        "TRANSLATE": "Перевести",
        "MOVE_TO_CATEGORY": "Категория",
        "DELETE": "Удалить",
        "STATUS_SUCCESS": "Статьи успешно обновлены",
        "STATUS_ERROR": "Ошибка обновления статей",
        "STATUS_SKIPPED": "1 article with unpublished edits was skipped — open it to publish or discard. | {count} articles with unpublished edits were skipped — open them to publish or discard.",
        "STATUS_SKIPPED_ALL": "These articles have unpublished edits — open each to publish or discard.",
        "CATEGORY_SUCCESS": "Articles moved successfully",
        "CATEGORY_ERROR": "Failed to move articles",
        "DELETE_CONFIRM_TITLE": "Удаление статьи | Удалить статьи {count}",
        "DELETE_CONFIRM_DESCRIPTION": "Это действие будет окончательно удалено выбранной статьи. Это действие не может быть отменено. | Это действие будет окончательно удалено {count} выбранных статей. Это действие нельзя отменить.",
        "DELETE_CONFIRM": "Удалить",
        "DELETE_SUCCESS": "Статьи успешно удалены",
        "DELETE_ERROR": "Не удалось удалить статьи"
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Новая категория",
        "EDIT_CATEGORY": "Редактировать категорию",
        "SEARCH_PLACEHOLDER": "Search categories...",
        "CATEGORIES_COUNT": "{n} категорий | {n} категорий",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Категории ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} статьи) | {categoryName} ({categoryCount} статьи)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "Категорий не найдено",
        "SUBTITLE": "Категории появятся здесь. Вы можете добавить категорию, нажав на кнопку 'Новая категория'."
      },
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching categories",
        "SUBTITLE": "We couldn't find any categories matching your search. Try a different term."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} статьи | {count} статьи"
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Категория успешно создана",
            "ERROR_MESSAGE": "Не удалось создать категорию"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Категория успешно обновлена",
            "ERROR_MESSAGE": "Не удается обновить категорию"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Категория успешно удалена",
            "ERROR_MESSAGE": "Не удается удалить категорию"
          }
        },
        "HEADER": {
          "CREATE": "Создать категорию",
          "EDIT": "Редактировать категорию",
          "DESCRIPTION": "Изменение категории обновит категорию на портале.",
          "PORTAL": "Портал",
          "LOCALE": "Local"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Имя",
            "PLACEHOLDER": "Имя категории",
            "ERROR": "Необходимо указать имя"
          },
          "SLUG": {
            "LABEL": "Метка",
            "PLACEHOLDER": "Метка категории для url",
            "ERROR": "Необходимо указать метку",
            "HELP_TEXT": "app.chatwoot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Описание",
            "PLACEHOLDER": "Укажите краткое описание категории.",
            "ERROR": "Необходимо описание"
          }
        },
        "BUTTONS": {
          "CREATE": "Создать",
          "EDIT": "Обновить",
          "CANCEL": "Отменить"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "Нет доступных локалей | {n} локаль | {n} локалей",
      "NEW_LOCALE_BUTTON_TEXT": "Новая локаль",
      "SEARCH_PLACEHOLDER": "Search locales...",
      "SEARCH_EMPTY_STATE": {
        "TITLE": "No matching locales",
        "SUBTITLE": "We couldn't find any locales matching your search. Try a different term."
      },
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} статьи | {count} статьи",
        "CATEGORIES_COUNT": "{count} категория | {count} категории",
        "DEFAULT": "По умолчанию",
        "DRAFT": "Черновик",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Сделать по умолчанию",
          "MOVE_TO_DRAFT": "Move to draft",
          "PUBLISH_LOCALE": "Publish locale",
          "CUSTOMIZE_CONTENT": "Localize content",
          "SELECT_POPULAR_CONTENT": "Select recommended content",
          "DELETE": "Удалить"
        }
      },
      "POPULAR_CONTENT_DIALOG": {
        "TITLE": "Recommended content",
        "DESCRIPTION": "Pick up to 3 categories and 6 articles to feature on this locale's help center home page. Drag them into the order you want visitors to see.",
        "SEARCH": "Поиск...",
        "EMPTY": "No matching results",
        "ADD_ANOTHER": "Add another...",
        "SLOTS_LEFT": "{count} slots left",
        "OVERRIDING_DEFAULTS": "Overriding defaults for this locale",
        "CONFIRM": "Save recommendations",
        "CATEGORIES": {
          "LABEL": "Recommended categories",
          "ARTICLES_COUNT": "No articles | {count} article | {count} articles"
        },
        "ARTICLES": {
          "LABEL": "Recommended articles",
          "IN_CATEGORY": "in {category}",
          "UNCATEGORIZED": "Без категории"
        },
        "API": {
          "SUCCESS_MESSAGE": "Recommended content updated successfully",
          "ERROR_MESSAGE": "Unable to update recommended content. Try again."
        }
      },
      "CONTENT_DIALOG": {
        "TITLE": "Localize content",
        "DESCRIPTION": "Set values specific to this locale. Anything left blank falls back to the default locale.",
        "NAME": {
          "LABEL": "Имя"
        },
        "PAGE_TITLE": {
          "LABEL": "Заголовок страницы"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст заголовка"
        },
        "API": {
          "SUCCESS_MESSAGE": "Locale content updated successfully",
          "ERROR_MESSAGE": "Unable to update locale content. Try again."
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Добавить новую локаль",
        "DESCRIPTION": "Выберите язык, на котором будет написана эта статья. Этот язык будет добавлен в ваш список переводов, и вы сможете добавить другие языки позже.",
        "COMBOBOX": {
          "PLACEHOLDER": "Выберите язык..."
        },
        "STATUS": {
          "LABEL": "Статус",
          "OPTIONS": {
            "LIVE": "Опубликовано",
            "DRAFT": "Черновик"
          }
        },
        "API": {
          "SUCCESS_MESSAGE": "Локаль успешно добавлен",
          "ERROR_MESSAGE": "Не удалось добавить локаль. Попробуйте еще раз."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "Сохранение...",
          "SAVED": "Сохранено"
        },
        "PREVIEW": "Предпросмотр",
        "PUBLISH": "Опубликовано",
        "PUBLISH_CHANGES": "Publish changes",
        "PUBLISH_CHANGES_SUCCESS": "Changes published successfully",
        "PUBLISH_CHANGES_ERROR": "Could not publish changes",
        "SAVE_IN_PROGRESS": "Still saving your latest changes — please try again in a moment.",
        "DISCARD_CHANGES": "Discard changes",
        "DISCARD_CHANGES_SUCCESS": "Changes discarded",
        "DISCARD_CHANGES_ERROR": "Could not discard changes",
        "PENDING_CHANGES": "Pending changes",
        "VIEW_CHANGES": "View unpublished changes",
        "DRAFT": "Черновик",
        "ARCHIVE": "Архив",
        "BACK_TO_ARTICLES": "Назад к статьям"
      },
      "PENDING_CHANGES_POPOVER": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "This article has draft changes that aren't live yet. Apply them before changing the status, or discard them?",
        "APPLY": "Apply changes",
        "DISCARD": "Discard changes"
      },
      "DIFF_DIALOG": {
        "TITLE": "Unpublished changes",
        "DESCRIPTION": "Compare your draft against the version that's currently live.",
        "TITLE_LABEL": "Название"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Больше параметров",
        "UNCATEGORIZED": "Без категории",
        "EDITOR_PLACEHOLDER": "Напишите что-нибудь..."
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Параметры статьи",
        "META_DESCRIPTION": "Мета описание",
        "META_DESCRIPTION_PLACEHOLDER": "Добавить мета-описание",
        "META_TITLE": "Мета-заголовок",
        "META_TITLE_PLACEHOLDER": "Добавить мета-заголовок",
        "META_TAGS": "Мета теги",
        "META_TAGS_PLACEHOLDER": "Добавить мета-теги"
      },
      "API": {
        "ERROR": "Ошибка при сохранении статьи"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Новый портал",
      "PORTALS": "Портал",
      "CREATE_PORTAL": "Создание и управление несколькими порталами",
      "ARTICLES": "статьи",
      "DOMAIN": "домен",
      "PORTAL_NAME": "Имя портала"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Создать новый портал",
      "DESCRIPTION": "Дайте вашему порталу название и создайте удобочитаемый slug для URL. Вы сможете изменить оба этих параметра позже в настройках.",
      "CONFIRM_BUTTON_LABEL": "Создать",
      "NAME": {
        "LABEL": "Имя",
        "PLACEHOLDER": "Руководство пользователя | Chatwoot",
        "MESSAGE": "Выберите имя для вашего портала.",
        "ERROR": "Необходимо указать имя"
      },
      "SLUG": {
        "LABEL": "Метка",
        "PLACEHOLDER": "руководство пользователя",
        "ERROR": "Необходимо указать метку",
        "FORMAT_ERROR": "Пожалуйста, введите правильное короткое имя, например: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Логотип",
          "IMAGE_UPLOAD_ERROR": "Не удалось загрузить изображение! Попробуйте снова",
          "IMAGE_UPLOAD_SUCCESS": "Изображение успешно добавлено. Пожалуйста, нажмите сохранить, чтобы сохранить подпись",
          "IMAGE_DELETE_SUCCESS": "Логотип успешно удалён",
          "IMAGE_DELETE_ERROR": "Не удалось удалить логотип",
          "IMAGE_UPLOAD_SIZE_ERROR": "Размер изображения должен быть меньше, чем {size}MB"
        },
        "NAME": {
          "LABEL": "Имя",
          "PLACEHOLDER": "Имя портала",
          "ERROR": "Необходимо указать имя"
        },
        "HEADER_TEXT": {
          "LABEL": "Текст заголовка",
          "PLACEHOLDER": "Текст заголовка портала"
        },
        "PAGE_TITLE": {
          "LABEL": "Заголовок страницы",
          "PLACEHOLDER": "Заголовок страницы портала"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Ссылка на домашнюю страницу",
          "PLACEHOLDER": "Ссылка на главную страницу портала",
          "ERROR": "Введите правильный URL. Ссылка на главную страницу должна начинаться с 'http://' или 'https://'."
        },
        "SLUG": {
          "LABEL": "Метка",
          "PLACEHOLDER": "Slug портала"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Виджет онлайн чата",
          "PLACEHOLDER": "Выберите виджет онлайн чата",
          "HELP_TEXT": "Выберите виджет онлайн-чата, который появится в вашем центре помощи",
          "NONE_OPTION": "Нет виджета"
        },
        "BRAND_COLOR": {
          "LABEL": "Цвет бренда"
        },
        "SAVE_CHANGES": "Сохранить изменения"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Свой домен",
          "LABEL": "Свой домен:",
          "DESCRIPTION": "Вы можете разместить ваш портал на собственном домене. Например, если ваш сайт — yourdomain.com, и вы хотите, чтобы ваш портал был доступен по адресу docs.yourdomain.com, просто введите это в это поле.",
          "STATUS_DESCRIPTION": "Ваш портал начнет работать, как только он будет проверен.",
          "PLACEHOLDER": "Пользовательский домен портала",
          "EDIT_BUTTON": "Редактировать",
          "ADD_BUTTON": "Добавить пользовательский домен",
          "STATUS": {
            "LIVE": "Онлайн",
            "PENDING": "Ожидание проверки",
            "ERROR": "Проверка не удалась"
          },
          "DIALOG": {
            "ADD_HEADER": "Добавить пользовательский домен",
            "EDIT_HEADER": "Редактировать пользовательский домен",
            "ADD_CONFIRM_BUTTON_LABEL": "Добавить домен",
            "EDIT_CONFIRM_BUTTON_LABEL": "Обновить домен",
            "LABEL": "Свой домен",
            "PLACEHOLDER": "Пользовательский домен портала",
            "ERROR": "Требуется пользовательский домен",
            "FORMAT_ERROR": "Пожалуйста, введите корректный URL домена, например docs.yourdomain.com"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Настройка DNS",
            "DESCRIPTION": "Войдите в учетную запись с вашим DNS провайдером и добавьте запись CNAME для поддомена, указывающего на chatwoot.help",
            "COPY": "CNAME успешно скопирован",
            "SEND_INSTRUCTIONS": {
              "HEADER": "Отправить инструкции",
              "DESCRIPTION": "Если вы предпочитаете иметь кого-то из вашей команды разработчиков, вы можете ввести адрес электронной почты ниже, и мы отправим им необходимые инструкции.",
              "PLACEHOLDER": "Введите их email",
              "ERROR": "Введите правильный адрес электронной почты",
              "SEND_BUTTON": "Отправить"
            }
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Удалить {portalName}",
          "HEADER": "Удалить портал",
          "DESCRIPTION": "Окончательно удалить этот портал. Это действие необратимо",
          "DIALOG": {
            "HEADER": "Вы уверены, что хотите удалить {portalName}?",
            "DESCRIPTION": "Это необратимое действие, которое нельзя отменить.",
            "CONFIRM_BUTTON_LABEL": "Удалить"
          }
        },
        "EDIT_CONFIGURATION": "Изменить конфигурацию"
      },
      "LAYOUT_CONTENT": {
        "HEADER": "Образец",
        "DESCRIPTION": "Pick the layout that fits how your visitors read.",
        "LAYOUT": {
          "CLASSIC": {
            "TITLE": "Classic",
            "DESCRIPTION": "A welcoming home page with search and featured topics."
          },
          "SIDEBAR": {
            "TITLE": "Documentation",
            "DESCRIPTION": "Side-by-side navigation that keeps every guide a click away."
          }
        },
        "SOCIAL_LINKS": {
          "HEADER": "Social links",
          "DESCRIPTION": "Add the handle for each network and your help center builds the full link. Shown in the documentation layout footer.",
          "PLACEHOLDER": "handle",
          "ADD": "Add social link",
          "REMOVE": "Удалить"
        },
        "SAVE": "Сохранить изменения"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Портал создан успешно",
          "ERROR_MESSAGE": "Невозможно создать портал"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Портал успешно обновлен",
          "ERROR_MESSAGE": "Не удалось обновить портал"
        }
      }
    },
    "PDF_UPLOAD": {
      "TITLE": "Загрузить PDF документ",
      "DESCRIPTION": "Загрузить PDF документ для автоматической генерации FAQ с помощью ИИ",
      "DRAG_DROP_TEXT": "Перетащите ваш PDF файл сюда или нажмите кнопку \"Выбрать\"",
      "SELECT_FILE": "Выбрать PDF файл",
      "ADDITIONAL_CONTEXT_LABEL": "Дополнительный контекст (Опционально)",
      "ADDITIONAL_CONTEXT_PLACEHOLDER": "Предоставьте любой дополнительный контекст или инструкции для генерации FAQ...",
      "UPLOADING": "Загружаем...",
      "UPLOAD": "Загрузить и обработать",
      "CANCEL": "Отменить",
      "ERROR_INVALID_TYPE": "Пожалуйста, выберите корректный файл PDF",
      "ERROR_FILE_TOO_LARGE": "Размер файла должен быть меньше 512MB",
      "ERROR_UPLOAD_FAILED": "Не удалось загрузить PDF. Пожалуйста, попробуйте еще раз."
    },
    "PDF_DOCUMENTS": {
      "TITLE": "PDF документы",
      "DESCRIPTION": "Управление загруженными документами PDF и сгенерированными FAQ",
      "UPLOAD_PDF": "Загрузить PDF",
      "UPLOAD_FIRST_PDF": "Загрузите первый PDF",
      "UPLOADED_BY": "Загружен",
      "GENERATE_FAQS": "Сгенерировать FAQ",
      "GENERATING": "Создание...",
      "CONFIRM_DELETE": "Вы уверены, что хотите удалить {filename}?",
      "EMPTY_STATE": {
        "TITLE": "Документов PDF пока нет",
        "DESCRIPTION": "Загрузите PDF документы для автоматического сгенерированные FAQ с помощью ИИ"
      },
      "STATUS": {
        "UPLOADED": "Готово",
        "PROCESSING": "Обрабатывается",
        "PROCESSED": "Выполнено",
        "FAILED": "Не удалось"
      }
    },
    "CONTENT_GENERATION": {
      "TITLE": "Генерация контента",
      "DESCRIPTION": "Загрузите PDF документы для автоматического генерации FAQ с помощью ИИ",
      "UPLOAD_TITLE": "Загрузить PDF документ",
      "DRAG_DROP": "Перетащите ваш PDF файл сюда или нажмите кнопку \"Выбрать\"",
      "SELECT_FILE": "Выбрать PDF файл",
      "UPLOADING": "Обработка документа...",
      "UPLOAD_SUCCESS": "Документ успешно обработан!",
      "UPLOAD_ERROR": "Не удалось загрузить документ. Пожалуйста, попробуйте еще раз.",
      "INVALID_FILE_TYPE": "Пожалуйста, выберите корректный файл PDF",
      "FILE_TOO_LARGE": "Размер файла должен быть меньше 512MB",
      "GENERATED_CONTENT": "Генерировать FAQ контент",
      "PUBLISH_SELECTED": "Опубликовать выбранные",
      "PUBLISHING": "Публикация...",
      "FROM_DOCUMENT": "Из документа",
      "NO_CONTENT": "Сгенерированный контент недоступен. Загрузите документ PDF, чтобы начать.",
      "LOADING": "Загрузка сгенерированного контента..."
    }
  }
}
